/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {OverviewPeriodRange, OverviewTopProduct} from '../../../../util/interfaces';

import {getOverviewProducts} from '../../../../util/requestSender';

import {useOverviewSection} from '../useOverviewSection';

import TopProducts from './topProducts';

interface Props {
    accountIds: Array<string>;
    period: OverviewPeriodRange;
}

export default function TopProductsController({accountIds, period}: Props) {
    const section = useOverviewSection<OverviewTopProduct>({request: getOverviewProducts, accountIds, period});

    return <TopProducts {...section} />;
}
